import request from '@/utils/request'
/**
 *获取已预约订单列表
 * @param {*} data 
 */
export function getAppointList(data){
    return request({
        url:'/appoint/appointList',
        method:'post',
        data
    })
}
/**
 *获取预约列表
 * @param {*} data 
 */
export function timeList(data){
    return request({
        url:'/appoint/list',
        method:'post',
        data
    })
}
/**
 *获取用户列表
 * @param {*} data 
 */
 export function deliveryList(data){
    return request({
        url:'/delivery/list',
        method:'post',
        data
    })
}
/**
 *预约配置-操作-确定按钮
 * @param {*} data 
 */
 export function comfirmBt(data){
    return request({
        url:'/appoint/determine',
        method:'post',
        data
    })
}
/**
 *预约配置-操作-取消按钮
 * @param {*} data 
 */
 export function cancelBt(data){
    return request({
        url:'/appoint/cancel',
        method:'post',
        data
    })
}
/**
 *删除时间段
 * @param {*} data 
 */
 export function cancelTime(data){
    return request({
        url:'/appoint/cancelPeriod',
        method:'post',
        data
    })
}
/**
 *获取出库面单数据
 * @param {*} data 
 */
 export function getSettlementSheet(data){
    return request({
        url:'/appoint/appointSendDetail',
        method:'post',
        data
    })
}
// /**
//  *获取用户发货列表
//  * @param {*} data 
//  */
//  export function sendOrders(data){
//     return request({
//         url: '/allocationCentre/settlementSheet',
//         method: 'post',
//         data
//     })
// }
/**
 *出库结算
 * @param {*} data 
 */
 export function confirmSettlement(data){
    return request({
        url:'/allocationCentre/settlementBySendId',
        method:'post',
        data
    })
}
/**
 *获取派送列表
 * @param {*} data 
 */
 export function getDeliveryList(data){
    return request({
        url:'/delivery/deliveryList',
        method:'post',
        data
    })
}
/**
 *更新派送消息
 * @param {*} data 
 */
 export function updateDelivery(data){
    return request({
        url:'/delivery/updateDelivery',
        method:'post',
        data
    })
}
/**
 *获取消息列表
 * @param {*} data 
 */
 export function getFeedbackList(data){
    return request({
        url:'/delivery/getFeedbackList',
        method:'post',
        data
    })
}
/**
 *获取消息列表
 * @param {*} data 
 */
 export function postDeliveryFeedback(data){
    return request({
        url:'/delivery/deliveryFeedback',
        method:'post',
        data
    })
}

/**
 *批量出库结算
 * @param {*} data 
 */
 export function mulOutStoreToPay(data){
    return request({
        url:'/allocationCentre/batchSettlementBySendId',
        method:'post',
        data
    })
}

/**
 *派送已入库 批量出库结算
 * @param {*} data 
 */
 export function deliverMulOutStoreToPay(data){
    return request({
        url:'/allocationCentre/batchConfirmSettlement',
        method:'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/book.js